import { Controller } from "@hotwired/stimulus"

// 바로 체험 시작 — 제출을 잠시 붙잡고 "준비중" 안내를 보여준다.
//
// ⚠️ 대기는 **브라우저에서만** 한다. 서버에서 요청을 붙잡으면 방어가 아니라 공격 도구가
// 된다: 발급은 실측 80ms 인데 5초씩 물고 있으면 Puma 스레드(5개)가 금방 차서, 동시 5건만
// 보내도 박스 전체가 응답을 멈춘다. 공격자는 응답을 기다리지 않고 병렬로 보내므로 비용은
// 전부 우리 쪽이다. 자동 제출 방어는 허니팟·서명 토큰·시간 검사·IP 상한이 맡는다.
//
// 부수 효과로 사람은 Demo::BotCheck 의 최소 경과시간(2초)을 여유 있게 통과한다.
export default class extends Controller {
  static targets = ["overlay"]
  static values = { delay: { type: Number, default: 2000 } }

  // Turbo 가 뒤로가기용으로 캐시한 화면을 되살릴 때, 오버레이가 켜진 채 복원되면
  // 아무것도 못 누르는 화면이 된다. 붙을 때마다 초기 상태로 되돌린다.
  connect() {
    this.submitting = false
    this.overlayTarget.classList.add("hidden")
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  submit(event) {
    // requestSubmit() 이 부르는 두 번째 submit 은 그대로 통과시킨다.
    if (this.submitting) return

    event.preventDefault()
    this.submitting = true
    this.overlayTarget.classList.remove("hidden")

    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }
}
